import { memo } from "react";
import { UserPlus } from "lucide-react";
import type { ModeratorSummonEntry } from "../../store/slices/qualitySlice";

function fmtTime(ts: number): string {
  if (!ts) return "";
  const d = new Date(ts);
  const hh = d.getHours().toString().padStart(2, "0");
  const mm = d.getMinutes().toString().padStart(2, "0");
  const ss = d.getSeconds().toString().padStart(2, "0");
  return `${hh}:${mm}:${ss}`;
}

/**
 * Kalite Planı — `moderator.summon` transcript bandı. Moderatör bir
 * gereksinimi kapatmak için oturuma bilirkişi (tanık uzman) çağırdığında
 * akışa bu belirgin band düşer. Bilirkişinin kendi konuşma turları ayrıca
 * TranscriptTurn üzerinde "Bilirkişi · oylamaya katılmaz" rozeti taşır
 * (witnessId ↔ speakerId eşleşmesi, qualitySlice.witnessById).
 */
export const ModeratorSummonBand = memo(function ModeratorSummonBand({
  summon,
}: {
  summon: ModeratorSummonEntry;
}) {
  return (
    <aside
      role="note"
      aria-label={`Bilirkişi çağrıldı: ${summon.witnessName}`}
      className="glass relative flex items-center gap-3 rounded-xl border border-violet-400/30 bg-[linear-gradient(90deg,hsl(262_70%_58%/0.14),hsl(262_70%_58%/0.04))] px-4 py-3 shadow-[inset_0_0_0_1px_hsl(262_70%_58%/0.12)]"
    >
      <span
        className="grid h-8 w-8 flex-none place-items-center rounded-full border border-violet-400/40 bg-violet-500/15 text-violet-200"
        aria-hidden
      >
        <UserPlus className="h-4 w-4" />
      </span>
      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-baseline gap-x-2 gap-y-0.5">
          <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-violet-300">
            Bilirkişi çağrıldı
          </span>
          <span className="truncate text-sm font-semibold text-fg-strong">
            {summon.witnessName}
          </span>
        </div>
        {summon.requirement ? (
          <p
            className="mt-0.5 line-clamp-2 text-xs leading-snug text-fg-muted"
            title={summon.requirement}
          >
            {summon.requirement}
          </p>
        ) : null}
      </div>
      <span className="hidden sm:inline font-mono text-[11px] tabular-nums text-fg-subtle">
        {fmtTime(summon.receivedAt)}
      </span>
    </aside>
  );
});
